import React, { useState } from 'react';
import { Row, Col, Card, Button, Spinner, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { usePrinterService } from '../../../common/hooks/usePrinterService';

export const XmlCommandCard: React.FC = () => {
  const [xmlCommand, setXmlCommand] = useState('');
  const [xmlReply, setXmlReply] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const printerService = usePrinterService();

  const handleSend = async () => {
    if (!xmlCommand.trim()) {
      toast.error('Proszę wpisać polecenie XML');
      return;
    }
    setIsLoading(true);
    try {
      const result = await printerService.sendXmlCommand(xmlCommand);
      setXmlReply(atob(result.packet?.value ?? ''));
      toast.success('Polecenie wysłane pomyślnie');
    } catch (err) {
      const errorMsg =
        err instanceof Error ? err.message : 'Błąd wysyłania polecenia';
      console.error('Error sending XML command:', err);
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Row className="mb-4">
      <Col lg={8}>
        <Card>
          <Card.Header>
            <Card.Title className="mb-0">Wysłanie polecenia XML</Card.Title>
          </Card.Header>
          <Card.Body>
            <p className="text-muted">
              Wyślij niestandardowe polecenie XML do drukarki.
            </p>

            <Form.Group className="mb-3">
              <Form.Label>Polecenie XML</Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                value={xmlCommand}
                onChange={e => setXmlCommand(e.target.value)}
                placeholder="Wklej tutaj polecenie XML..."
                disabled={isLoading}
              />
            </Form.Group>

            <div className="d-flex gap-2 flex-wrap">
              <Button
                variant="primary"
                onClick={handleSend}
                disabled={isLoading || !xmlCommand.trim()}
              >
                {isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Wysyłanie...
                  </>
                ) : (
                  'Wyślij polecenie'
                )}
              </Button>
            </div>

            {xmlReply && (
              <Form.Group className="mt-4">
                <Form.Label>Odpowiedź XML</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  value={xmlReply}
                  readOnly
                  className="bg-light"
                />
              </Form.Group>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
